import { SCAN_JURISDICTIONS, SCAN_REQUIREMENTS } from '/b2b/domains/constants';

import { hasOnlyEmailMethods } from '/b2b/domains/format';

export const getScanResultStatus = result => {
    if (result?.status === 'error' || result?.status === 'in_progress') return result.status;

    const jurisdiction = result?.jurisdictions?.[SCAN_JURISDICTIONS.CALIFORNIA] || {};

    if (jurisdiction.status === 'error') return 'error';
    if (jurisdiction.status === 'warning') return 'warning';

    return result?.status || 'failed';
};

/**
 * Whether a failed subject rights result is missing an online method: every method it detected is
 * email. The result label and the requirement text both follow it.
 *
 * @param {Object} result - A scan result row
 * @returns {boolean} True for a failed subject rights result whose detected methods are all email
 */
export const isOnlineMethodMissing = result =>
    result?.requirement === SCAN_REQUIREMENTS.SUBJECT_RIGHTS_METHOD &&
    getScanResultStatus(result) === 'failed' &&
    hasOnlyEmailMethods(
        result.jurisdictions?.[SCAN_JURISDICTIONS.CALIFORNIA]?.fields?.accessMethods
    );

/**
 * The locale path of the text that states what a result's requirement is.
 *
 * @param {Object} result - A scan result row
 * @returns {string} The locale path
 */
export const getRequirementPath = result =>
    `domains.siteScan.${result?.requirement}.${
        isOnlineMethodMissing(result) ? 'onlineMethodRequirement' : 'requirement'
    }`;
